<script lang="ts">
	import { timestampDate, timestampFromDate } from "@bufbuild/protobuf/wkt";
	import { Helper } from "flowbite-svelte-v1";
	import { getContext } from "svelte";
	import type { Poll } from "#gen/forms/v1/poll_pb.js";
	import type { User } from "#gen/identities/v1/identities_pb.js";
	import Toggle from "#lib/components/Toggle.svelte";
	import DateTimeInput from "#lib/components/calendar/DateTimeInput.svelte";
	import { DEFAULT_DATE_FORMAT_OPTIONS, DEFAULT_DATE_PLACEHOLDER } from "#lib/components/page/components/poll/constants.js";
	import type { Writable } from "svelte/store";

	interface Props {
		poll: Poll;
		onChange?: (poll: Poll) => void;
	}

	const user: Writable<User> = getContext("user");

	let { poll, onChange }: Props = $props();

	function handleCountdownStartChange(date: Date) {
		onChange?.({ ...poll, preVoteStart: timestampFromDate(date) });
	}

	function handleEndToggle(event: Event) {
		const target = event.target as HTMLInputElement;
		if (target.checked) {
			onChange?.({ ...poll, preVoteStart: undefined });
		} else {
			onChange?.({ ...poll, preVoteStart: timestampFromDate(new Date()) });
		}
	}
</script>

<form class="flex w-full flex-col gap-4" onsubmit={e => e.preventDefault()}>
	<div class="flex w-full flex-col gap-4 rounded-lg border p-4">
		<Helper>Show countdown x amount of days and time before the poll opens.</Helper>
		<div class="flex w-full flex-col gap-2 rounded-lg border p-4">
			<DateTimeInput class="grid w-full grid-cols-2" dateLabel="Start date" datePlaceholder={DEFAULT_DATE_PLACEHOLDER} dateFormatOptions={DEFAULT_DATE_FORMAT_OPTIONS} timeLabel="Start time" timezone={poll.timezone || $user.timezone} timestamp={poll.preVoteStart ? timestampDate(poll.preVoteStart) : undefined} onChange={handleCountdownStartChange} disabled={!poll.preVoteStart} />
		</div>
	</div>
	<Toggle class="w-fit" checked={!poll.preVoteStart} on:change={e => handleEndToggle(e)}>Always show countdown</Toggle>
</form>
